module.exports = __webpack_public_path__ + "img/Pic_PH.5462be78.png";